import { createAsyncThunk } from '@reduxjs/toolkit';

import type { FetchModelosCartaArArgs, ModelosCartaArPagina } from '../../types/arModelosCarta';
import { modelosCartaArService } from './services';

export const fetchModelosCartaAr = createAsyncThunk<
  ModelosCartaArPagina,
  FetchModelosCartaArArgs,
  { rejectValue: string }
>('secretariaArbitralModelosCarta/fetch', async (args, { rejectWithValue }) => {
  try {
    return await modelosCartaArService.listar(args);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar os modelos de carta',
    );
  }
});
